import Vue from 'vue';

export default {
    // offerings
    loadAllOffersSuccess(state, payload) {
        Vue.set(state.offers, 'data', payload);
        Vue.set(state.offers, 'dataIsLoading', false);
    },
    loadAllOffersError(state) {
        Vue.set(state.offers, 'dataIsLoading', false);
        Vue.set(state.offers, 'hasError', true);
    },

    // categories
    loadAllOfferCategoriesSuccess(state, payload) {
        Vue.set(state.offers, 'categories', payload);
        Vue.set(state.offers, 'categoriesIsLoading', false);
    },
    loadAllOfferCategoriesError(state) {
        Vue.set(state.offers, 'categoriesIsLoading', false);
        Vue.set(state.offers, 'hasError', true);
    },

    // locations
    loadAllOfferLocationsSuccess(state, payload) {
        Vue.set(state.offers, 'locations', payload);
        Vue.set(state.offers, 'locationsIsLoading', false);
    },
    loadAllOfferLocationsError(state) {
        Vue.set(state.offers, 'locationsIsLoading', false);
        Vue.set(state.offers, 'hasError', true);
    },

};
